module.exports = __webpack_public_path__ + "media/images/matchdaySelector__md2-1af4fac77675a7c4946b50935ef19ec2.png";